import { defineMessages } from 'react-intl'

const messages = defineMessages({
  search: {
    id: 'Search.search',
    defaultMessage: 'Sök',
  },
  clearSearch: {
    id: 'Search.clearSearch',
    defaultMessage: 'Rensa sök',
  },
  searchProducts: {
    id: 'Search.searchProducts',
    defaultMessage: 'Sök produkter',
  },
  noResults: {
    id: 'Search.noResults',
    defaultMessage: 'Inga produkter kunde hittas. Försök igen!',
  },
  showingResultsFor: {
    id: 'Search.showingResultsFor',
    defaultMessage: 'Visar resultat för {query}',
  },
  searchingFor: {
    id: 'Search.searchingFor',
    defaultMessage: 'Söker efter {query}',
  },
  suggestions: {
    id: 'search.suggestions',
    defaultMessage: 'Förslag',
  },
  searchForProducts: {
    id: 'search.searchForProducts',
    defaultMessage: 'Sök efter produkter',
  },
})

export default messages
